// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"u9-z"};